import { useCallback, useEffect, useRef, useState } from 'react';

import { logos } from 'components/home/insurace/insurace-slider/insurace-logos';
import Slider from 'react-slick';
import { SlidesItems } from 'components/home/insurace/insurace-slider/components';
import styles from 'styles/Insurace.module.scss';
import { useCulture } from 'context/CultureContext';

const InsuranceSlider = () => {
    const [windowWidth, setWindowWidth] = useState();
    const [slidesToShow, setSlidesToShow] = useState(2);
    const [currentSlides, setCurrentSlides] = useState(2);
    const sliderRef = useRef();
    const { culture } = useCulture();
    const insuranceLogo = logos(culture);

    const settings = {
        infinite: true,
        speed: 1000,
        slidesToScroll: 1,
        arrows: false,
        centerPadding: '500px',
        lazyLoad: true
    };

    const handleSidesToShow = (windowWidth) => {
        if (windowWidth > 1600) {
            setSlidesToShow(4);
            setCurrentSlides(4);
        }
        if (windowWidth > 1300 && windowWidth < 1600) {
            setSlidesToShow(4);
            setCurrentSlides(4);
        }
        if (windowWidth > 700 && windowWidth < 1300) {
            setSlidesToShow(4);
            setCurrentSlides(4);
        }
        if (windowWidth < 700) {
            setSlidesToShow(2);
            setCurrentSlides(2);
        }
    };

    const incrementSlidesToShow = useCallback(() => {
        if (currentSlides < insuranceLogo.length) {
            setCurrentSlides(currentSlides + 4);
        };
    }, [currentSlides]);

    useEffect(() => {
        const handleWindowWidth = () => {
            window.innerWidth && setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleWindowWidth);

        handleSidesToShow(window.innerWidth);

        return () => window.removeEventListener('resize', handleWindowWidth);
    }, []);

    useEffect(() => {
        handleSidesToShow(windowWidth);
    }, [windowWidth]);

    return (
        <div className={styles.slideContainer}>
            <div
                className={styles.arrowContainer}
                onClick={() => {
                    incrementSlidesToShow();
                    sliderRef.current.slickNext();
                }}
            >
                &#10094;
            </div>
            <Slider
                {...settings}
                ref={sliderRef}
                slidesToShow={slidesToShow}
                className={styles.slider}
            >
                {insuranceLogo.map((logo, index) => (
                    (index <= currentSlides) && <SlidesItems key={index} logo={logo} />
                ))}
            </Slider>
            <div
                className={styles.arrowContainer}
                onClick={() => {
                    incrementSlidesToShow();
                    sliderRef.current.slickPrev();
                }}
            >
                &#10095;
            </div>
        </div>
    );
};

export default InsuranceSlider;
